/* tslint:disable */
/* eslint-disable */
/**
 * Webmeet service API
 * Service for web meetings management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMeetingShortResponseDto
 */
export interface GetMeetingShortResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetMeetingShortResponseDto
     */
    id?: string;
    /**
     * Meeting Id in third-party calendar
     * @type {string}
     * @memberof GetMeetingShortResponseDto
     */
    externalId?: string;
    /**
     * Meeting creator user id
     * @type {string}
     * @memberof GetMeetingShortResponseDto
     */
    creator?: string;
    /**
     * Meeting title
     * @type {string}
     * @memberof GetMeetingShortResponseDto
     */
    title?: string;
    /**
     * Start time of the meeting
     * @type {string}
     * @memberof GetMeetingShortResponseDto
     */
    startTime?: string;
    /**
     * End time of the meeting
     * @type {string}
     * @memberof GetMeetingShortResponseDto
     */
    endTime?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetMeetingShortResponseDto
     */
    participants?: Array<string>;
}

/**
 * Check if a given object implements the GetMeetingShortResponseDto interface.
 */
export function instanceOfGetMeetingShortResponseDto(value: object): boolean {
    return true;
}

export function GetMeetingShortResponseDtoFromJSON(json: any): GetMeetingShortResponseDto {
    return GetMeetingShortResponseDtoFromJSONTyped(json, false);
}

export function GetMeetingShortResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMeetingShortResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'creator': json['creator'] == null ? undefined : json['creator'],
        'title': json['title'] == null ? undefined : json['title'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'participants': json['participants'] == null ? undefined : json['participants'],
    };
}

export function GetMeetingShortResponseDtoToJSON(value?: GetMeetingShortResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'externalId': value['externalId'],
        'creator': value['creator'],
        'title': value['title'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'participants': value['participants'],
    };
}

